import React, { useEffect, useRef } from 'react';

const CareersInteractiveHeader = ({ containerRef }) => {
  const canvasRef = useRef();

  let ctx, blob1, blob2, blob3;
  let mouse = { x: 0, y: 0 };
  const lerp = (start, end, time) => start + (end - start) * time;

  const setSize = () => {
    canvasRef.current.width = containerRef.current.offsetWidth;
    canvasRef.current.height = containerRef.current.offsetHeight;
    mouse = { x: canvasRef.current.width * 0.5, y: -500 };
    blob1 = blob2 = blob3 = mouse;
  };

  const followMouse = (e) => {
    mouse.x = e.x;
    mouse.y = e.y;
  };

  function draw() {
    const canvasHeight = canvasRef.current.height;
    const canvasWidth = canvasRef.current.width;
    const size = canvasHeight / 2.5;
    const offset = canvasWidth / 18;

    ctx.fillStyle = 'black';

    const blob1X = lerp(blob1.x, mouse.x + offset, 0.025);
    const blob1Y = lerp(blob1.y, canvasHeight * 0.5 - mouse.y * 0.1, 0.02);
    ctx.beginPath();
    ctx.rect(blob1X, blob1Y, size * 0.8, size * 0.8);
    ctx.closePath();
    ctx.fill();
    blob1 = { x: blob1X, y: blob1Y };

    const blob2X = lerp(blob2.x, mouse.x, 0.03);
    const blob2Y = lerp(blob2.y, mouse.y * 0.8, 0.05);
    ctx.beginPath();
    ctx.arc(blob2X, blob2Y, size, 0, Math.PI * 2);
    ctx.closePath();
    ctx.fill();
    blob2 = { x: blob2X, y: blob2Y };

    const blob3X = lerp(blob3.x, mouse.x - offset * 2, 0.035);
    const blob3Y = lerp(blob3.y, canvasHeight * 0.5 - mouse.y * 0.3, 0.05);
    ctx.beginPath();
    ctx.rect(blob3X, blob3Y, size, size);
    ctx.closePath();
    ctx.fill();
    blob3 = { x: blob3X, y: blob3Y };
  }

  function animate() {
    if (canvasRef.current) {
      ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
      draw();
      requestAnimationFrame(animate);
    }
  }

  useEffect(() => {
    ctx = canvasRef.current.getContext('2d');
    setSize();
    containerRef.current.addEventListener('mousemove', followMouse);
    animate();

    return () => {
      containerRef.current?.removeEventListener('mousemove', followMouse);
    };
  }, []);

  useEffect(() => {
    // disable resizing on iOS to prevent bugs with navbar appearing
    if (/iPad|iPhone|iPod/.test(window.navigator.userAgent)) return null;
    window.addEventListener('resize', setSize);
    return () => window.removeEventListener('resize', setSize);
  });

  return <canvas ref={canvasRef} />;
};

export default CareersInteractiveHeader;
